
import { Fragment } from 'vue-fragment';
import CasaBreadcrumbs from '@/components/CasaBreadcrumbs.vue';
import breadcrumbsMixin from '@/mixins/breadcrumbs-mixin';
export default {
    components: { CasaBreadcrumbs, Fragment },
    mixins: [breadcrumbsMixin]
};
